import React from 'react';
import { Tag, Form, Modal, Badge, Table, message, Flex, DatePicker, TimePicker, Divider } from 'antd';
import { PhoneOutlined, CopyOutlined } from '@ant-design/icons';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import dayjs from 'dayjs';
import { safeCall } from '../../utils/jsbridge';
import Remarks from "../order/remarks-action";

export default ({ appointments, onChange, ...props }) => { 
    const [isOpen, setIsOpen] = React.useState(false);
    const [modalTitle, setModalTitle] = React.useState('');
    const [action, setAction] = React.useState();
    const [form] = Form.useForm();
    const [current, setCurrent] = React.useState();
    const [maxDate, setMaxDate] = React.useState();
    const [minDate, setMinDate] = React.useState();

    React.useEffect(() => {
        switch(action) {
            case 'update':
                setModalTitle('选择新的日期');
                setMinDate(dayjs());
                setMaxDate(undefined);
                break;
            case 'create':
                setModalTitle('选择日期');
                setMinDate(dayjs());
                setMaxDate(undefined);
                break;
        }
    }, [action]);

    const columns = [
        {
            title: '客户信息',
            width: 75,
            render: (text, item) => (<div style={{ whiteSpace: 'nowrap' }}>
                { item.status === 0 
                    ? <Badge count={item?.times} size="small" color='red' /> 
                    : ( item.status === 8 ? <Badge count={item?.times} size="small" color='gray' /> : <Badge count={item?.times} size="small" color='green' /> )
                }
                { item.appointmentTime ? dayjs(item.appointmentTime).format('HH:mm') : '未预约' }
            </div>),
        },
        {
            title: '地址',
            render: (text, item) => {
                const diffDay = dayjs().diff(dayjs(item.createTime), 'day');
                const diffHour = dayjs().diff(dayjs(item.createTime), 'hour');

                return (
                    <div>
                        {item?.resourceType === 'GOODS_CARD' && <Tag color='orange'>次卡</Tag>}
                        <CopyToClipboard text={`${item.city}${item.county}${item.community || ''}${item.address}`} onCopy={() => message.success('复制成功')}>
                            <a style={{textDecoration: 'underline'}}>{item.county}{item.community || ''}{item.address}</a>
                        </CopyToClipboard>
                        <div>
                            <span>{dayjs(item.createTime).format('MM/DD')}</span>
                            {item?.status === 0 && <span style={{color: diffDay >= 2 ? (diffDay >= 3 ? 'red' : 'orange') : '', fontWeight: diffDay >= 2 ? 'bold' : ''}}>
                                ({diffDay}天{diffHour % 24}小时)
                            </span>}
                            <span style={{margin: '0 8px 0 8px'}}>{item.customerName}</span>
                            <a onClick={() => safeCall(item.phoneNo)}><PhoneOutlined /></a>
                        </div>
                        {item?.remark && <div>买家备注：{item.remark}</div>}
                        {item?.orderRemark && <div style={{fontStyle: 'italic', borderTop: '1px dashed #ddd', margin: '3px 0 0 0', padding: '3px 0 0 0'}}>
                            <span style={{margin: '0 5px 0 0'}}>商家备注({item.orderRemark.split('$$').length}条)：{item.orderRemark.split('$$')[0]}</span>
                            <Remarks remark={item.orderRemark} orderId={item.resourceId} shopId={item.shopId} onChange={() => {
                                    onChange?.(item);
                                }} 
                            />
                        </div>}
                    </div>
                )
            }
        },
        {
            title: '操作',
            dataIndex: 'status',
            fixed: 'right',
            width: 60,
            render: (text, item) => {
                return (
                    <Flex gap={6} wrap='wrap' style={{textAlign: 'center', flexDirection: 'column'}}>
                        {['NORMAL', 'GOODS'].includes(item?.resourceType) && <a href={`/order/detail?parentOrderId=${item.resourceId}&shopId=${item.shopId}`}>订单</a>}
                        {item?.resourceType === 'GOODS_CARD' && <a href={`/goods-card/card-detail?cardId=${item.resourceId}&shopId=${item.shopId}`}>次卡</a>}
                        {text !== 6 && text !== 8 && <a onClick={() => updateStatus(item)}>改期</a> }
                        {text !== 6 && text !== 8 && <a onClick={() => finish(item)}>完成</a> }
                        {text === 6 && <a onClick={() => updateStatus({...item, action: 'create'})}>售后</a> }
                        {
                            text !== 6 && 
                            item.resourceType === 'GOODS_CARD' && 
                            item?.appointmentTime && 
                            <a onClick={() => finish({id: item.id, shopId: item.shopId, times: item.times, status: 6})}>完成</a>
                        }
                    </Flex>
                )
            }
        }
    ];

    const finish = async ({id, times, shopId}) => { 
        Modal.confirm({
            type: 'warning',
            title: '该日程确定已经完成？',
            onOk: async () => { 
                
                await requestUpdate({
                    id,
                    times,
                    shopId,
                    status: 6,
                });
            }
        });
    };

    const updateStatus = async (item) => { 
        
        item = {...item}

        delete item.status;
            
        if(item?.appointmentTime) {
            form.setFieldsValue({
                date: dayjs(item?.appointmentTime, 'YYYY-MM-DD'),
                time: dayjs(item?.appointmentTime),
            })
        }

        setCurrent(item);
        setIsOpen(true);        
    }

    const requestUpdate = async (item) => { 
        const {id, shopId, times, action, ...others} = item;
        // 参数检查
        if(!id || !shopId || !times) {
            message.error('参数错误');
            return;
        }
        // let body = { times, ...others }

        const res = await fetch(`/api/order/appointment/update?id=${id}&shopId=${shopId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item)
        });

        const result = await res.json();

        if(result?.success) {
            message.success('提交成功');
            setTimeout(() => {
                onChange?.();
            }, 200);
        } else {
            message.error(result.data);
        }
    }

    const submit = async () => { 
        const values = await form.validateFields();
        // console.log(values, '============');
        const { date, time } = values;
        // 合并date time
        const appointmentTime = date ? dayjs(date).format('YYYY-MM-DD') + ' ' + dayjs(time).format('HH:mm:ss') : null;
        const data = {...current, appointmentTime}
        // console.log(data, '=========d===');

        await requestUpdate(data);
        setIsOpen(false);
    };

    return (
        <>
            <Modal open={isOpen} destroyOnClose={true} onOk={submit} onCancel={() => setIsOpen(false)} title={modalTitle}>
                <Form form={form}>
                    <Form.Item
                        label="日期"
                        name={'date'}
                    >
                        <DatePicker
                            maxDate={maxDate}
                            minDate={minDate}   
                            format="YYYY-MM-DD"
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                            // initialValue={dayjs(current.appointmentTime, 'YYYY-MM-DD')}
                        />
                    </Form.Item>

                    <Form.Item
                        label="时间"
                        name={"time"}
                        initialValue={dayjs('09:00', 'HH:mm')}
                    >
                        <TimePicker

                            format="HH:mm"
                            minuteStep={10}
                        />
                    </Form.Item>
                </Form>
            </Modal>
            <Table rowKey={'id'} dataSource={appointments} size='small' showHeader={false} columns={columns} {...props} />
        </>
    )
};